import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import SectionWrapper from '../SectionWrapper/SectionWrapper'
import { TMissionOrBadge } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import { Smartico } from '../../../core/Smartico'
import { useTranslation } from '../../../hooks/useTranslation'

export const missionStatus = (mission: TMissionOrBadge) => {
	if (mission.is_locked) {
		return 'Locked'
	} else if (mission.is_completed) {
		return 'Completed'
	} else if (mission.is_opted_in) {
		return 'In Progress'
	} else if (mission.is_requires_optin) {
		return 'Requires Opt-in'
	} else {
		return ''
	}
}

export const getStatusClassName = (mission: TMissionOrBadge) => {
	switch (missionStatus(mission)) {
		case 'Locked':
			return 'locked'
		case 'Completed':
			return 'completed'
		case 'In Progress':
			return 'in_progress'
		case 'Requires Opt-in':
			return 'requires_optin'
		default:
			return null
	}
}

interface MissionsSectionProps {
	id?: string
}

const MissionsSection: React.FC<MissionsSectionProps> = ({ id }) => {
	const missions = useSelector((state: RootState) => state.missions.missions)
	const { getTexts } = useTranslation(false)

	const filterMissions = missions.filter((mission) => !mission.only_in_custom_section && !mission.is_locked)

	return (
		<SectionWrapper title={getTexts('missions')} id={id} >
			{filterMissions?.map((mission) => {
				const { is_locked: isLocked, is_completed: isCompletedMission, is_opted_in: isOptedIn, is_requires_optin: isRequiresOptin, cta_action, cta_text } = mission
				const needOptin = isRequiresOptin && !isOptedIn && !isLocked
				const statusKey = getStatusClassName(mission)
				return (
					<div className={`mission-card ${statusKey}`} key={mission.id} onClick={() => Smartico.dp(`dp:gf_missions&id=${mission.id}&hide_main=true`)}>
						{statusKey !== null && <div className={`mission-status ${statusKey}`}>{statusKey && getTexts(statusKey)}</div>}
						<div className="wrap-wrap-wrap">
							<div className="mission-image" style={{ backgroundImage: `url(${mission.image})` }} />
							<div className="mission-title" dangerouslySetInnerHTML={{ __html: mission.name }}></div>
						</div>
						<div className={`mission-progress ${statusKey}`}>
							<div className="progress-bar">
								<div className="progress-fill" style={{ width: `${mission.progress}%` }}></div>
							</div>
							<div className="progress-info">
								<div className="progress-value">{mission.progress}%</div>
								<div className="progress-info">
									<div className="icon"></div>
									<div className="label">{mission.reward}</div>
								</div>
							</div>
						</div>
						{needOptin && (
							<div
								className={`btn ${isCompletedMission ? 'disabled' : ''}`}
								onClick={async (e) => {
									e.stopPropagation()
									;(await Smartico.apiReady).requestMissionOptIn(mission.id)
								}}
							>
								{getTexts('opt_in')}
							</div>
						)}
						{!needOptin && !isLocked && !isCompletedMission && cta_action && cta_text && (
							<div className={`deposit-btn`} onClick={() => Smartico.dp(cta_action)}>
								{cta_text}
							</div>
						)}
					</div>
				)
			})}
		</SectionWrapper>
	)
}

export default MissionsSection
